import { Coordinate, Location, TileSize } from "game-common/models"

interface StairSprite {
    x: number; y: number; rotation: number
    scale: { set(x: number, y: number): void }
    texture?: { orig: { width: number; height: number } }
}

/** Up artwork opens to the left; down artwork opens to the right. Mirror their
 * entrance toward the local safe spot and anchor the flight's base to its cell. */
export const applyStairOrientation = (sprite: StairSprite, at: Coordinate, type: string, exit?: Location): void => {
    if (type !== "stairs-up" && type !== "stairs-down") return
    const dx = exit ? exit.x - (at.x + .5) * TileSize : 0
    const dy = exit ? exit.y - (at.y + .5) * TileSize : 0
    const horizontal = Math.abs(dx) >= Math.abs(dy)
    const left = horizontal && dx < 0
    const flip = !!exit && (type === "stairs-up") !== left
    const width = sprite.texture?.orig.width ?? TileSize
    const height = sprite.texture?.orig.height ?? TileSize
    const sx = flip ? -1 : 1
    sprite.scale.set(sx, 1)
    sprite.rotation = 0
    // Larger flights extend above the cell, with their base centered on its floor.
    sprite.x = at.x * TileSize + (TileSize - width) / 2 + (flip ? width : 0)
    sprite.y = at.y * TileSize + TileSize - height
}
